/* Version B add-to-bag forms (sb26b sections + cards): add in place and slide the cart
   out instead of loading the full /cart page. The theme's own <product-form> already
   does this, so it is skipped. If the add itself fails, the old full-page post runs. */
(function () {
  if (window.sbCartDrawer) return;
  window.sbCartDrawer = true;

  // The "Get 15% off" corner tab and the Tidio chat bubble sit above the open cart and cover Check out.
  var css = document.createElement('style');
  css.textContent = 'body:is(.mini-cart--opening,.mini-cart--open) :is(.sbt,#tidio-chat){display:none!important}';
  document.head.appendChild(css);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !(form instanceof HTMLFormElement) || form.closest('product-form')) return;
    if (!/\/cart\/add\/?$/.test(new URL(form.action, location.href).pathname)) return;
    var miniCart = document.querySelector('mini-cart');
    if (!document.querySelector('cart-drawer') || !miniCart || !miniCart.renderContents) return;

    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '0.6'; }
    var done = function () { if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; } };

    // Card size buttons carry the variant on the button itself (name="id" value=...).
    var sub = e.submitter && e.submitter.name ? e.submitter : null;
    var data = new FormData(form);
    if (sub && !data.has(sub.name)) data.append(sub.name, sub.value);
    // Same one-request render the theme's product-form uses: the add returns the cart drawer HTML.
    data.append('sections', miniCart.getSectionsToRender().map(function (s) { return s.section; }));
    data.append('sections_url', location.pathname);
    miniCart.setActiveElement(btn || document.activeElement);
    var added = false;

    fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        added = true;
        if (item.sections) miniCart.renderContents(item);
        else document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sb26b-cart-drawer', productVariantId: data.get('id'), cartData: item });
        }
        done();
      })
      .catch(function () {
        done();
        // Already in the cart: just show it. Otherwise let the browser post as before.
        if (added) return document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        if (sub) {
          var keep = document.createElement('input');
          keep.type = 'hidden'; keep.name = sub.name; keep.value = sub.value;
          form.appendChild(keep);
        }
        HTMLFormElement.prototype.submit.call(form);
      });
  });
})();
